import script from "./ReplayScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./ReplayScreen.vue?vue&type=script&setup=true&lang=js"

import "./ReplayScreen.vue?vue&type=style&index=0&id=0a8dd184&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a8dd184"]])

export default __exports__